import styled from "styled-components";
import { theme as lexusTheme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

// Default white background with a small box shadow.
export const Shadow = styled.div`
    background: ${lexusTheme.colors.white};
    border-radius: 4px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
`;
